import { dtoToModelDef, TimestampedDTO } from './timestamped';
import { buildMapper } from '@core/utils/object-helpers';
import { Location } from '@core/models/location.model';
import { dtoToModel as toUnitLocationModel, UnitLocationDTO } from './unit-location';

export interface LocationDTO extends TimestampedDTO {
    id?: number,
    name?: string,
    locationTypeId?: number,
    clientId?: number,
    address?: unknown | null,
    latitude?: unknown | null,
    description?: unknown | null,
    longitude?: unknown | null,
    active?: boolean,
    UnitLocationModel?: UnitLocationDTO
}

export type LocationListResponseDTO = Array<LocationDTO>;

export const dtoToModel = buildMapper<LocationDTO, Location>({
    mappings: {
        UnitLocationModel: value => value ? toUnitLocationModel(value) : undefined,
        ...dtoToModelDef,
    },
});

export interface LocationTypeDTO {
    id: number,
    name: string
}

export type LocationTypeListResponseDTO = Array<LocationTypeDTO>;

/**
 * Payload de alta y edición. No reusa `LocationDTO` porque la API acepta menos
 * campos de los que devuelve, y porque distingue el alta de la edición.
 */
export interface LocationRequestDTO {
    id?: number,
    /** Solo se envía al crear: la API rechaza el renombre porque el nombre sincroniza con Zee */
    name?: string,
    locationTypeId: number,
    /** Solo se envía al crear: la edición no cambia el cliente */
    clientId?: number,
    description: string | null,
    address: string | null,
    latitude: number | null,
    longitude: number | null,
    active: boolean,
}
